// Module
var code = "<template class=\"mooring-components-tab\">\n  <require from=\"./delivery-container\"></require>\n  <delivery-container if.bind=\"data.productionOrderId > 0\" production-order-id.bind=\"data.productionOrderId\"></delivery-container>\n</template>\n";
// Exports
export default code;